type VerifyUserSourceQuery = {
  shouldVerifyUserSource: boolean;
  token: string | null;
  deviceId: string | null;
  ga4ClickId: string | null;
  ga4SessionId: string | null;
};

export function parseVerifyUserSourceQuery(searchParams: URLSearchParams): VerifyUserSourceQuery {
  return {
    shouldVerifyUserSource: searchParams.get('verify-user-source') === 'true',
    token: searchParams.get('token'),
    deviceId: searchParams.get('deviceId'),
    ga4ClickId: searchParams.get('ga4-client-id'),
    ga4SessionId: searchParams.get('ga4-session-id'),
  };
}
